var _style, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIDashboards(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "logosandtypes_com",
    viewBox: "0 0 150 150.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st1{fill-rule:evenodd;clip-rule:evenodd;fill:#fcb621}")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3_2_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_1_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer_3",
    d: "M0 .2h150v150H0V.2z",
    fill: "none"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "idashboards"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M128.7 28.2c-1.6-.4-4.9-1-8.2.7L104 33.1v12.3l-15.3 4.8.2-13.2-14.8 3.8s-11.9 1.6-13.6 17.1l.4 67.6s.4 9.7 11.3 8.5l17-5.7V79L80 82.5l.5-20.7 26.8-7.5v68l8.7-2.9c5.5-2.1 9.8-3.9 12.5-8 2.5-3.8 2.9-6.8 3-12.4l.1-59c0-4.7.4-8.6-2.9-11.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M57.8 125.9c-.2-9-.4-68.4-.4-68.4S56 43.9 74 37.4L121.1 25 88.3 13.3c-1-.4-2.3-.6-3.4-.6-2.2 0-2.7.3-4.3.7l-42.4 9.7c-7.4 2-12.6 3.3-16.6 9.6-2.6 4.1-3.2 8-3.2 11.9l.5 62.9c0 4.1.3 5.4 2.3 7.8 1.2 1.4 1.9 1.6 4 2.8l33.3 15.3c.1.1.1.1.2.1l.2.2c.4.3.8.6 1.3.9.9.5 1.9.9 2.8 1.1-1.8-.8-5.1-3.1-5.2-9.8z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIDashboards);
export default __webpack_public_path__ + "static/media/i-dashboards.9c349daa19b53a899051f22be75bfa1c.svg";
export { ForwardRef as ReactComponent };